import { ReactElement } from "react";
import { useParams } from "react-router-dom";
import { ContactDTO, ContactType, FindAllContactsFilters, FindContactsTargetResponse } from "../../../../lib/filters/dto";
import { useAppSelector } from "../../../../lib/redux/hooks";
import { TargetListDTO, TargetListPageEnum } from "../../../targetList/dto";
import { ImportFromCSV } from "../../contacts/csv";
import { ImportFromDatabase } from "./database";
import { ImportType } from "./importType";
import { TargetListCompaniesList } from "./list/index";
import { ContactsCounterDTO, ContactsIdsResponseDTO } from "../../contacts/dto";
import { ProjectDTO } from "../../../projects/dto";
import { EmailsMessagesDTO, FindAllCustomMailsResponseDTO } from "../../../projects/mails/dto";
import { PersonDTO } from "../../../database/people/dto";

interface Props {
  showPopup: boolean
  setShowPopup: (action: boolean) => void
  selectedIds: { contactId: string, companyId: string }[]
  setSelectedIds: (action: { contactId: string, companyId: string }[]) => void
  filters: FindAllContactsFilters
  setFilters: (action: Partial<FindAllContactsFilters>) => void
  setPage: (action: number) => void
  resetFilters: () => void
  contacts: {
    total: number
    page: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number
    data: { company: ContactDTO<ContactType.COMPANY>, employees: PersonDTO[] }[]
  }
  toActivate: number
  counters: ContactsCounterDTO
  targetContactIds: ContactsIdsResponseDTO[]
  targetList: TargetListDTO
  project: ProjectDTO
  isLoadingEmailsHistory: boolean
  emailsHistory: { messages: EmailsMessagesDTO[] }
  templates: FindAllCustomMailsResponseDTO
}

export function TargetListCompanies(props: Props) {
  const targetId = useParams().targetId as string;
  const { selectedIds, setSelectedIds, setShowPopup, counters, toActivate, showPopup, filters, setFilters, setPage, resetFilters, contacts, targetContactIds, targetList, project, templates } = props
  const targetListsState = useAppSelector((state) => state.targetList);

  const pageMap = new Map<TargetListPageEnum, ReactElement>([
    [TargetListPageEnum.ADD, <ImportType />],
    [TargetListPageEnum.CSV, <ImportFromCSV contactType={ContactType.COMPANY} targetListId={targetId} />],
    [TargetListPageEnum.DB, <ImportFromDatabase targetContactIds={targetContactIds} />],
    [TargetListPageEnum.LIST, <TargetListCompaniesList
      templates={templates}
      isLoadingEmailsHistory={props.isLoadingEmailsHistory}
      emailsHistory={props.emailsHistory}
      project={project}
      counters={counters}
      targetList={targetList}
      toActivate={toActivate}
      contacts={contacts}
      showPopup={showPopup}
      setShowPopup={arg => setShowPopup(arg)}
      selectedIds={selectedIds}
      setSelectedIds={arg => setSelectedIds(arg)}
      filters={filters}
      setFilters={function (action: Partial<FindAllContactsFilters>): void {
        setFilters(action)
      }}
      setPage={function (action: number): void {
        setPage(action)
      }}
      resetFilters={function (): void {
        resetFilters()
      }} />],
  ]);

  return (
    <div className="h-full max-h-full">
      {pageMap.get(targetListsState.targetListPage)}
    </div>
  );
}
